import React, { useEffect } from "react";
import BarComponent from "./BarComponent";
import PieChartComponent from "./PieChartComponent";
import AreaChartComponent from "./AreaChartComponent";
import { useDispatch, useSelector } from "react-redux";
import { getAuditLogs } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import ComposedChartComponent from "./ComposedChartComponent";
import LineChartComponent from "./LineChartComponent";
import LineChartComponentForMultiple from "./LineChartComponentForMultiple";
import PieChartComponentForDomains from "./PieChartComponentForDomains";
import BarChartBreakdown from "./BarChartBreakdown";


export default function GraphComponent(props) {
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	const dispatch = useDispatch();
	const { getAuditLogsDataInCMOverviewSeeker } = bindActionCreators(Actions, dispatch)
	return (
		<>
			{
				props.type === "Bar" &&
				<>
					<BarComponent name={props.name} data={props.data} />
				</>
			}
			{
				props.type === "Pie" &&
				<>
					<PieChartComponent name={props.name} />
				</>
			}
			{
				props.type === 'Area' &&
				<>
					<AreaChartComponent name={props.name} />
				</>
			}
			{
				props.type === 'Composed' &&
				<>
					<ComposedChartComponent name={props.name} />
				</>
			}
			{
				props.type === 'Line' &&
				<>
					<LineChartComponent name={props.name} />
				</>
			}
			{
				props.type === 'Multiple' &&
				<>
					<LineChartComponentForMultiple name={props.name} />
				</>
			}
			{
				props.type === 'PieDomains' &&
				<>
					<PieChartComponentForDomains name={props.name} />
				</>
			}
			{
				props.type === "BarChartBreakdown" &&
				<>
					<BarChartBreakdown name={props.name} />
				</>
			}
		</>)
}